import { Heading } from "Components/Heading";
import { useDocumentTitle } from "Components/Hooks";
import { UpdateCoverageDatesProps } from "SharedConstants/Schema";

export function UpdateCoverageDates(props: UpdateCoverageDatesProps) {
  useDocumentTitle(
    `Update Coverage Dates - ${props.TitleProps.PageTitleSuffix}`,
  );
  return (
    <>
      <Heading {...props} title="Please Update Your Coverage Period" />
      <div>
        This policy has a start date that is earlier than tomorrow. Please
        choose a start date of tomorrow or later.
      </div>
      <div>
        <a href={props.Url}>Click here to update coverage dates.</a>
      </div>
    </>
  );
}
